import React from 'react';
import Box from '@/components/UI/box/Box';
import Skeleton from '@/components/UI/skeleton/Skeleton';
import styles from './CancellationRulesSkeleton.module.scss';
const CancellationRulesSkeleton = () => {
  return <Box className={styles['cancellation-skeleton']} data-sentry-element="Box" data-sentry-component="CancellationRulesSkeleton" data-sentry-source-file="CancellationRulesSkeleton.tsx">
      <Box data-sentry-element="Box" data-sentry-source-file="CancellationRulesSkeleton.tsx">
        <Skeleton width={120} height={24} data-sentry-element="Skeleton" data-sentry-source-file="CancellationRulesSkeleton.tsx" />
        <Skeleton width={230} height={24} data-sentry-element="Skeleton" data-sentry-source-file="CancellationRulesSkeleton.tsx" />
      </Box>
      <Box data-sentry-element="Box" data-sentry-source-file="CancellationRulesSkeleton.tsx">
        <Skeleton width={120} height={24} data-sentry-element="Skeleton" data-sentry-source-file="CancellationRulesSkeleton.tsx" />
        <Skeleton width={230} height={24} data-sentry-element="Skeleton" data-sentry-source-file="CancellationRulesSkeleton.tsx" />
      </Box>
      <Box data-sentry-element="Box" data-sentry-source-file="CancellationRulesSkeleton.tsx">
        <Skeleton width={120} height={24} data-sentry-element="Skeleton" data-sentry-source-file="CancellationRulesSkeleton.tsx" />
        <Skeleton width={230} height={24} data-sentry-element="Skeleton" data-sentry-source-file="CancellationRulesSkeleton.tsx" />
      </Box>
    </Box>;
};
export default CancellationRulesSkeleton;